import type {ReactElement} from 'react';
import {ImageThumbnail} from '@Components/thumbnail/components/image-thumbnail/image-thumbnail';
import {ThumbnailType} from '@Components/thumbnail/thumbnail.types';
import {getVoiceFilterById} from '@Panels/ai-voice-panel/ai-voice-panel.library';
import {SelectorPillDropdown} from '@Panels/ai-voice-panel/components/selector-pill-dropdown/selector-pill-dropdown';
import type {SelectorPillDropdownContentParams} from '@Panels/ai-voice-panel/components/selector-pill-dropdown/selector-pill-dropdown.types';
import {VoiceProfilesDropdownPopup} from '@Panels/ai-voice-panel/components/voice-profiles-dropdown-popup';
import type {VoiceProfileSelectorProps} from './voice-profile-selector.types';
import {VOICE_PROFILE_SELECTOR_MODAL_PANEL_ID, VOICE_PROFILES_MODAL_MAX_HEIGHT} from './voice-profile-selector.types';
import styles from './voice-profile-selector.module.scss';

export function VoiceProfileSelector(props: VoiceProfileSelectorProps): ReactElement {
  const selectedProfile = getVoiceFilterById(props.selectedProfileId);

  const getTriggerAvatar = (): ReactElement | null => {
    if (!selectedProfile?.avatarUrl) {
      return null;
    }
    return <ImageThumbnail className={styles.avatar} data={{type: ThumbnailType.IMAGE, imageSrc: selectedProfile.avatarUrl, showSkeletonLoading: true, altText: ''}} />;
  };

  const getVoiceProfilesPopup = ({isSmallScreen, closeDropdown}: SelectorPillDropdownContentParams): ReactElement => {
    return (
      <VoiceProfilesDropdownPopup
        language={props.language}
        selectedProfileId={props.selectedProfileId}
        isSmallScreen={isSmallScreen}
        onProfileSelected={(id: number): void => {
          props.onProfileSelected(id);
          closeDropdown();
        }}
      />
    );
  };

  return (
    <SelectorPillDropdown
      title={window.i18next.t('pmwjs_voice_profile')}
      pillText={selectedProfile?.name ?? ''}
      leadingVisual={getTriggerAvatar()}
      pillClassName={styles.profilePill}
      popupClassName={styles.profilePopup}
      modalMaxHeight={VOICE_PROFILES_MODAL_MAX_HEIGHT}
      panelIdForModal={VOICE_PROFILE_SELECTOR_MODAL_PANEL_ID}
      renderPopupContent={getVoiceProfilesPopup}
    />
  );
}
